var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('youtube',{attrs:{"player-vars":{ autoplay: 0 },"player-height":"200","player-width":"100%","video-id":_vm.videoId},on:{"ready":() => {},"playing":() => {}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }